import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, Cpu, ArrowRight, AlertCircle } from "lucide-react";
import { api, setToken } from "../lib/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username, password });
      setToken(data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Σφάλμα σύνδεσης");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative">
      <div className="absolute inset-0 circuit-pattern opacity-20 pointer-events-none" />
      <div className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full bg-red-500/10 blur-3xl" />

      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-md bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center glow-green">
            <Cpu className="w-6 h-6 text-emerald-400" />
          </div>
          <h1 className="mt-4 text-2xl font-bold text-white">Repairzone Admin</h1>
          <p className="text-sm text-emerald-100/60 mt-1">Συνδεθείτε για πρόσβαση στο dashboard</p>
        </div>

        <form onSubmit={submit} className="pcb-card p-6 md:p-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-emerald-300/80">
              Username
            </label>
            <div className="mt-1 relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-emerald-300/60" />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoFocus
                className="w-full rounded-md bg-[#04101c] border border-emerald-900/70 pl-10 pr-3 py-2.5 text-sm text-white placeholder:text-emerald-100/30 focus:border-emerald-500 transition-colors outline-none"
                placeholder="Το username σας"
              />
            </div>
          </div>

          <div>
            <label className="text-xs uppercase tracking-wider text-emerald-300/80">
              Password
            </label>
            <div className="mt-1 relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-emerald-300/60" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-md bg-[#04101c] border border-emerald-900/70 pl-10 pr-3 py-2.5 text-sm text-white placeholder:text-emerald-100/30 focus:border-emerald-500 transition-colors outline-none"
                placeholder="Το password σας"
              />
            </div>
          </div>

          {error && (
            <div className="flex items-start gap-2 text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-md p-3">
              <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full rounded-md px-5 py-3 inline-flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? "Σύνδεση..." : (<>Σύνδεση <ArrowRight className="w-4 h-4" /></>)}
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-xs text-emerald-300/70 hover:text-emerald-300">
            ← Επιστροφή στην ιστοσελίδα
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
